import React from 'react';
import Helmet from 'react-helmet';
import Template from './template';

class Pledge extends React.Component {
  render() {
    const title = 'About Our Fair Housing Pledge';
    return (
      <Template title="Our Fair Housing Pledge">

        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title}/>
          <meta
            name="description"
            content={`Learn more about our fair housing pledge. Sotheby’s International Realty sells exquisite homes in premier locations across the US.`}/>
        </Helmet>

        <div>
          <p>
            Our company representatives are committed to following our fair housing pledge, which includes:
          </p>
          <ul className="list-default">
            <li>
              Providing equal professional service to all, without regard to race, color, religion, sex,
              handicap, familial status, national origin or other protected status of any prospective client,
              customer or resident of any community;
            </li>
            <li>
              Keeping informed about fair housing laws and practices, thereby expanding upon our customers' and
              clients' opportunities;
            </li>
            <li>
              Demonstrating through advertising and the media that everyone is welcome and no one is excluded;
            </li>
            <li>
              Informing our clients and customers about our rights and responsibilities under the fair housing
              laws;
            </li>
            <li>
              Documenting our efforts to provide equal professional service whenever possible;
            </li>
            <li>
              Respecting the diversity and differences within our customer base, and remaining informed on those
              differences in order to provide Truly Remarkable Service;
            </li>
            <li>
              Taking a positive approach to fair housing practices and aspiring to follow the letter and spirit
              of the law;
            </li>
            <li>
              Committing to continue in the development and implementation of fair housing practices in
              accordance with our leadership role in the real estate profession; and
            </li>
            <li>
              Refusing to tolerate non-compliance.
            </li>
          </ul>
        </div>
      </Template>
    );
  }
}

export default Pledge;



// WEBPACK FOOTER //
// ./src/components/about-us/pledge.js